export default function useTheme () {
    const theme = document.querySelector('body').getAttribute('theme');
    if (theme === 'cuotitas') {
        return {
            name: 'cuotitas',
            label: 'Cuotitas',
            title: 'Cuotitas',
            colorPrimary: '#2F4F83',
            colorAccent: '#2589f5',
        };
    }

    return {
        name: 'demo',
        label: 'tu empresa',
        title: 'Demo',
        colorPrimary: '#b61989',
        colorAccent: '#b61989',
    };
}
